import item from '../CollectionItems/muralForTheTerracePlazaHotel';

export default {
  location: 'mural-for-the-terrace-plaza-hotel',
  filename: 'mural-for-the-terrace-plaza-hotel-miro',
  title: item.name,
};
